// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Origens_DeleteOrigemInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/origens/deleteOrigem
 *
 * Deletes an origin (origem de orcamento).
 */
import { registerContract } from './validate'

export interface Origens_DeleteOrigemInput {
origem_id: number
}

registerContract('Origens_DeleteOrigemInput', {
  origem_id: { type: 'number',  required: true },
})
